<template>
  <div class="http">
    <h3>Тип запроса</h3>
    <v-select
      label="Тип запроса"
      height="40"
      hide-details
      item-color="#fee600"
      :items="['GET', 'POST']"
      v-model="data_local.typeRequest"
      solo
      @change="onChangeType"
    />
    <br />

    <!-- Если GET -->
    <template v-if="data_local.typeRequest === 'GET'">
      <h3>Postback url</h3>
      <v-textarea
        class="my_textarea"
        v-model="data_local.link"
        auto-grow
        placeholder="http://kakayato/link?subid={s}"
        @input="onInput"
      />
    </template>

    <!-- Если POST -->
    <template v-if="data_local.typeRequest === 'POST'">
      <h3>URL для POST-запроса</h3>
      <v-text-field
        height="40"
        v-model="data_local.postURL"
        placeholder="http://sitename"
        hide-details="auto"
        @input="onInput"
      />
      <br />
      <h3>Bearer-токен</h3>

      <v-text-field
        v-model="postToken"
        placeholder="Введите токен"
        hide-details
        solo
        @input="buildPostParams"
      />
      <div class="section-title">
        <div>
          <div class="section-name">Параметры запроса</div>
        </div>
      </div>
      <div class="post-columns">
        <div>
          <div class="post-column-title">Данные CRMCalls</div>
          <div class="post-column-hint">Что мы подставляем</div>
        </div>

        <div></div>

        <div>
          <div class="post-column-title">Поле получателя</div>
          <div class="post-column-hint">Поле которое вам нужно</div>
        </div>

        <div></div>
      </div>
      <div
        v-for="(row, index) in postRows"
        :key="index"
        class="post-row"
        :class="{ 'post-row--custom': row.source === 'custom' }"
      >
        <div class="source-field">
          <v-select
            v-model="row.source"
            :items="postSources"
            item-text="text"
            item-value="value"
            label="Что отправить"
            hide-details
            solo
            @change="onSourceChange(row)"
          />

          <v-tooltip v-if="row.source === 'custom'" top max-width="320">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="custom-info-icon" small v-bind="attrs" v-on="on">
                info
              </v-icon>
            </template>

            <span>
              Укажите точное название поля из fields. Например: city. Справа
              укажите название поля, которое вам нужно.
            </span>
          </v-tooltip>
        </div>
        <v-text-field
          v-if="row.source === 'custom'"
          v-model="row.customSource"
          label=""
          placeholder=""
          hide-details
          solo
          @input="onCustomSourceInput(row)"
        />

        <span class="post-arrow">→</span>

        <v-text-field
          v-model="row.target"
          label=""
          placeholder=""
          hide-details
          solo
          @input="buildPostParams"
        />

        <button
          v-if="postRows.length > 1"
          type="button"
          class="remove-row"
          @click="removePostRow(index)"
        >
          ×
        </button>
      </div>

      <button type="button" class="add-row" @click="addPostRow">
        + Добавить параметр
      </button>
      <div class="section-title">
        <div>
          <div class="section-name">Статические поля</div>
          <div class="section-hint">
            Эти значения отправляются без изменений
          </div>
        </div>
      </div>

      <div
        v-for="(row, index) in staticRows"
        :key="'static-' + index"
        class="post-row"
      >
        <v-text-field
          v-model="row.key"
          label="Поле получателя"
          placeholder="source"
          hide-details
          solo
          @input="buildPostParams"
        />

        <span class="post-arrow">→</span>

        <v-text-field
          v-model="row.value"
          label="Постоянное значение"
          placeholder="CRMCalls"
          hide-details
          solo
          @input="buildPostParams"
        />

        <button
          v-if="staticRows.length > 1"
          type="button"
          class="remove-row"
          @click="removeStaticRow(index)"
        >
          ×
        </button>
      </div>

      <button type="button" class="add-row" @click="addStaticRow">
        + Добавить статическое поле
      </button>
      <!-- <h3>Параметры запроса в формате JSON</h3>
      <v-textarea
        v-model="data_local.params"
        placeholder='{"phoneA":phoneA, "phone": propsName, "callName": propsCallName, "record": propsRecord, "target": propsTarget}'
        @input="onInput"
      /> -->
    </template>
    <button
      type="button"
      class="test-webhook-btn"
      :class="{ 'test-webhook-btn--get': data_local.typeRequest === 'GET' }"
      @click="openWebhookTest"
    >
      Проверить вебхук
    </button>
    <div
      v-if="testDialog"
      class="webhook-test-overlay"
      @click.self="closeWebhookTest"
    >
      <div class="webhook-test-modal">
        <v-card class="test-card">
          <div class="test-header">
            <div>
              <div class="test-title">Тестирование вебхука</div>
              <div class="test-subtitle">Проверьте данные перед отправкой</div>
            </div>

            <button
              type="button"
              class="test-close"
              aria-label="Закрыть проверку"
              :disabled="testLoading || testSending"
              @click="closeWebhookTest"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false">
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          </div>

          <div v-if="testLoading" class="test-loading">
            Готовим тестовый запрос...
          </div>

          <div v-else class="test-content">
            <div class="test-info-card" v-if="testRecipient">
              <div class="test-info-label">Получатель</div>
              <div class="test-info-value">{{ testRecipient }}</div>
            </div>

            <div class="test-info-card" v-if="testDisplayFields.length">
              <div class="test-info-label">Данные тестового звонка</div>
              <dl class="test-fields">
                <div v-for="(field, index) in testDisplayFields" :key="index">
                  <dt>{{ field.name }}</dt>
                  <dd>{{ field.value }}</dd>
                </div>
              </dl>
            </div>
            <div v-else-if="testRequestUrl" class="test-info-card">
              Будет отправлен тестовый вебхук с указанными в настройках данными.
            </div>

            <div v-if="testResult" class="test-result" :class="{ 'test-result--error': !testResult.ok }" role="status">
              <div class="test-result-title">{{ testResult.ok ? 'Вебхук отправлен' : 'Отправка не выполнена' }}</div>
              <div class="test-result-message">{{ testResult.message }}</div>
            </div>
          </div>

          <div class="test-actions">
            <button
              type="button"
              class="test-send-btn"
              :disabled="
                testLoading ||
                testSending ||
                !testRequestUrl ||
                (data_local.typeRequest === 'POST' &&
                  !Object.keys(testPayload).length)
              "
              @click="sendWebhookTest"
            >
              {{ testSending ? 'Отправляем...' : 'Отправить вебхук' }}
            </button>
          </div>
        </v-card>
      </div>
    </div>
    <!-- Вставка подстановок -->
    <div
      v-if="data_local.typeRequest === 'GET'"
      class="paste"
      @click="paste('phoneA')"
    >
      Вставить номер звонка
    </div>
    <div
      v-if="data_local.typeRequest === 'GET'"
      class="paste"
      @click="paste('phone')"
    >
      Вставить номер клиента
    </div>
    <div
      v-if="data_local.typeRequest === 'GET'"
      class="paste"
      @click="paste('callname')"
    >
      Вставить название обзвона
    </div>
    <div
      v-if="data_local.typeRequest === 'GET'"
      class="paste"
      @click="paste('target')"
    >
      Вставить название цели
    </div>
    <div
      v-if="data_local.typeRequest === 'GET'"
      class="paste"
      @click="paste('answer')"
    >
      Вставить текст ответа
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendHttp',
  props: ['data', 'edit_callback'],

  data() {
    return {
      postRows: [{ source: '', customSource: '', target: '' }],
      legacyParams: {},
      postToken: '',
      testRequestUrl: '',
      staticRows: [
        {
          key: '',
          value: '',
        },
      ],
      lastEmittedData: null,
      testDialog: false,
      testLoading: false,
      testSending: false,
      testPayload: {},
      testGetFields: [],
      testResult: null,

      postSources: [
        { text: 'Номер клиента', value: 'phone' },
        { text: 'Номер звонка', value: 'phoneA' },
        { text: 'ID лида', value: 'lead_id' },
        { text: 'Название обзвона', value: 'callname' },
        { text: 'Запись звонка', value: 'record' },
        { text: 'Название цели', value: 'target' },
        { text: 'Текст разговора', value: 'text' },
        { text: 'Название сценария', value: 'script' },
        { text: 'Название базы', value: 'base' },
        { text: 'Дата звонка — только входящий', value: 'date' },
        {
          text: 'Пользовательское поле',
          value: 'custom',
        },
      ],
      // Локальные данные, которые мы будем редактировать
      data_local: {
        link: '',
        typeRequest: 'GET',
        postURL: '',
        params: '{\n}',
      },
    };
  },

  computed: {
    testRecipient() {
      try { return new URL(this.testRequestUrl).host; } catch (_) { return ''; }
    },
    testDisplayFields() {
      if (this.data_local.typeRequest === 'GET') return this.testGetFields;
      return Object.entries(this.testPayload).filter(([key]) => !['header', 'answer', 'button', 'sub2'].includes(key)).map(([key, value]) => {
        const row = this.postRows.find((item) => item.target === key);
        const source = row ? row.source : key;
        const option = this.postSources.find((item) => item.value === source);
        const name = row && source === 'custom' ? row.customSource : (option ? option.text : key);
        return { name, value: this.formatTestValue(source, value) };
      });
    },
  },

  watch: {
    // При любом изменении входящего prop "data"
    // делаем глубокую копию в data_local,
    // чтобы данные блоков не пересекались
    data: {
      deep: true,
      immediate: true,
      handler(newVal) {
        const incomingData = JSON.stringify(newVal || {});

        if (incomingData === this.lastEmittedData) {
          this.lastEmittedData = null;
          return;
        }
        // Глубокая копия пропа
        const cloneData = JSON.parse(JSON.stringify(newVal || {}));

        this.postRows = [
          {
            source: '',
            customSource: '',
            target: '',
          },
        ];

        this.staticRows = [
          {
            key: '',
            value: '',
          },
        ];

        this.legacyParams = {};
        this.postToken = '';

        this.testDialog = false;
        this.testPayload = {};
        this.testResult = null;

        // Если тип запроса не задан — ставим GET
        if (!cloneData.typeRequest) {
          cloneData.typeRequest = 'GET';
        }

        // Для POST задаём дефолты, если вдруг пусто
        // if (cloneData.typeRequest === "POST") {
        //   if (!cloneData.postURL) {
        //     cloneData.postURL = "https://";
        //   }
        //   if (!cloneData.params) {
        //     cloneData.params = "{\n\tphoneNumber:\n }";
        //   }
        // }

        // Для GET, если link пуст, пусть будет пустая строка
        if (!cloneData.link) {
          cloneData.link = '';
        }
        if (cloneData.typeRequest === 'POST' && cloneData.params) {
          try {
            const parsedParams = JSON.parse(cloneData.params);
            this.postToken =
              typeof parsedParams.header === 'string'
                ? parsedParams.header
                : '';
            const rows = [];
            const legacyParams = {};

            Object.entries(parsedParams).forEach(([source, target]) => {
              // Статические поля разбираем отдельно
              if (
                source === 'static' &&
                target &&
                typeof target === 'object' &&
                !Array.isArray(target)
              ) {
                this.staticRows = Object.entries(target).map(
                  ([key, value]) => ({
                    key,
                    value,
                  }),
                );

                return;
              }

              // Токен уже записан в postToken
              if (source === 'header') {
                return;
              }

              // Обычное системное поле
              const available = this.postSources.some(
                (item) => item.value === source && source !== 'custom',
              );

              if (available && typeof target === 'string') {
                rows.push({
                  source,
                  customSource: '',
                  target,
                });

                return;
              }

              // Неизвестный строковый ключ считаем пользовательским полем
              if (typeof target === 'string') {
                rows.push({
                  source: 'custom',
                  customSource: source,
                  target,
                });

                return;
              }

              // Служебные параметры старого формата сохраняем без изменений
              legacyParams[source] = target;
            });

            this.postRows = rows.length ? rows : [{ source: '', target: '' }];

            this.legacyParams = legacyParams;
          } catch (err) {
            console.log('[POST PARAMS PARSE ERROR] Не удалось прочитать настройки полей');
          }
        }

        // Записываем в локальное состояние
        this.data_local = cloneData;
      },
    },
  },

  methods: {
    closeWebhookTest() {
      if (!this.testLoading && !this.testSending) this.testDialog = false;
    },
    formatTestValue(source, value) {
      if (source === 'lead_id') return 'Передаётся автоматически';
      if (source === 'record') return 'Ссылка на запись звонка';
      if (value === null || value === undefined || value === '') return 'Не заполнено';
      if (typeof value === 'boolean') return value ? 'Да' : 'Нет';
      if (Array.isArray(value)) return value.map((item) => this.formatTestValue('', item)).join(', ');
      if (typeof value === 'object') return 'Данные звонка';
      return String(value);
    },
    setWebhookTestResult(response) {
      const ok = Boolean(response && response.ok);
      const legacy = response && ('data' in response || 'status' in response);
      this.testResult = {
        ok,
        message: response && !legacy && response.message
          ? response.message
          : ok ? 'Получатель принял тестовый запрос.' : 'Проверьте адрес получателя, доступ и значения полей.',
      };
    },
    openWebhookTest() {
      this.testDialog = true;
      this.testLoading = true;
      this.testResult = null;
      this.testPayload = {};
      this.testGetFields = [];
      this.testRequestUrl = '';

      if (this.data_local.typeRequest === 'GET') {
        this.$http.post(
          'integrations/test_webhook_get_preview',
          {
            url: this.data_local.link,
          },
          (response) => {
            this.testLoading = false;

            if (!response || !response.ok) {
              this.testResult = { ok: false, message: 'Не удалось подготовить проверку. Проверьте адрес получателя.' };
              return;
            }

            this.testRequestUrl = response.url;
            this.testGetFields = response.fields || [];
          },
        );

        return;
      }

      this.buildPostParams();

      this.$http.post(
        'integrations/test_webhook_preview',
        {
          params: this.data_local.params,
        },
        (response) => {
          this.testLoading = false;

          if (!response || !response.ok) {
            this.testResult = { ok: false, message: 'Не удалось подготовить проверку. Проверьте настройки полей.' };
            return;
          }

          this.testRequestUrl = this.data_local.postURL;
          this.testPayload = response.body || {};
        },
      );
    },

    sendWebhookTest() {
      if (this.testSending || this.testLoading || !this.testRequestUrl) return;
      this.testSending = true;
      this.testResult = null;

      if (this.data_local.typeRequest === 'GET') {
        this.$http.post(
          'integrations/test_webhook_get_send',
          {
            url: this.testRequestUrl,
          },
          (response) => {
            this.testSending = false;
            this.setWebhookTestResult(response);
          },
        );

        return;
      }

      this.$http.post(
        'integrations/test_webhook_send',
        {
          url: this.data_local.postURL,
          webhookToken: this.postToken,
          body: this.testPayload,
        },
        (response) => {
          this.testSending = false;
          this.setWebhookTestResult(response);
        },
      );
    },
    addStaticRow() {
      this.staticRows.push({
        key: '',
        value: '',
      });
    },

    removeStaticRow(index) {
      this.staticRows.splice(index, 1);
      this.buildPostParams();
    },
    onCustomSourceInput(row) {
      row.target = row.customSource;
      this.buildPostParams();
    },
    onSourceChange(row) {
      if (row.source === 'custom') {
        row.customSource = '';
        row.target = '';

        // Пока пользователь не ввёл название поля — JSON не пересобираем
        return;
      }

      row.customSource = '';
      row.target = row.source;

      this.buildPostParams();
    },
    addPostRow() {
      this.postRows.push({
        source: '',
        customSource: '',
        target: '',
      });
    },

    removePostRow(index) {
      this.postRows.splice(index, 1);
      this.buildPostParams();
    },

    buildPostParams() {
      const params = {
        ...this.legacyParams,
      };

      const token = this.postToken.trim();

      if (token) {
        params.header = token;
      }

      this.postRows.forEach((row) => {
        const source =
          row.source === 'custom' ? row.customSource.trim() : row.source;
        const target = row.target.trim();

        if (source && target) {
          params[source] = target;
        }
      });

      const staticParams = {};

      this.staticRows.forEach((row) => {
        const key = row.key.trim();

        if (key) {
          staticParams[key] = row.value;
        }
      });

      if (Object.keys(staticParams).length) {
        params.static = staticParams;
      }

      this.data_local.params = JSON.stringify(params, null, 2);


      this.emitChange();
    },
    // Универсальная вставка значений
    paste(type) {
      // Логика по умолчанию: добавляем в link
      // (При желании можно разделить: если POST, то data_local.params += ...)
      this.data_local.link += `{${type}}`;
      this.emitChange();
    },

    // Срабатывает при вводе текста, уведомляем родителя
    onInput() {
      this.emitChange();
    },

    // При смене типа запроса (GET -> POST / POST -> GET)
    onChangeType() {
      // Если только что выбрали POST,
      // подставляем дефолтные значения, если их нет
      // if (this.data_local.typeRequest === "POST") {
      //   if (!this.data_local.postURL) {
      //     this.data_local.postURL = "https://";
      //   }
      //   if (!this.data_local.params) {
      //     this.data_local.params = "{\n\tphoneNumber:\n }";
      //   }
      // }
      if (this.data_local.typeRequest === 'POST') {
        this.buildPostParams();
        return;
      }
      this.emitChange();
    },

    // Функция, уведомляющая родителя о новых данных
    emitChange() {
      if (typeof this.edit_callback === 'function') {
        // На всякий случай передаём КОПИЮ, чтобы исключить мутацию извне
        const cloned = JSON.parse(JSON.stringify(this.data_local));
        this.lastEmittedData = JSON.stringify(cloned);
        this.edit_callback(cloned);
      }
    },
  },
};
</script>

<style scoped>
.modal_header {
  display: flex;
  align-self: flex-end;
}

.http {
  max-width: 600px;
  margin: 0 auto;
  width: 600px;
}

.modal_body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 554px;
}

.save {
  padding: 10px 20px 12px;
  background: #4b5eff;
  border-radius: 8px;
  margin: 16px 0 0 0;
}

.paste {
  padding: 9px 20px 10px;
  background: #ffffff;
  display: inline-block;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  margin: 12px 0 0 10px;
  cursor: pointer;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  color: #2b2d33;
}

.modal_title {
  margin-top: 32px;
  margin-bottom: 32px;
}

h3 {
  margin-bottom: 12px;
  text-align: left;
}

.close {
  margin-right: 52px;
  margin-top: 20px;
}

.post-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.post-row .v-select,
.post-row .v-text-field {
  flex: 1;
}

.post-arrow {
  font-size: 22px;
}

.add-row {
  padding: 10px 16px;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  color: #4b5eff;
}

.remove-row {
  font-size: 24px;
  color: #d32f2f;
}

.webhook-test-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
}

.webhook-test-modal {
  position: relative;
  z-index: 10000;
  width: 650px;
  max-width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 16px;
  text-align: left;
}

.section-title {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 44px;
  margin: 28px 0 14px;
  text-align: center;
}

.section-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);

  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #fff;
  background: #4b5eff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
}

.section-name {
  color: #2b2d33;
  font-size: 17px;
  font-weight: 700;
}

.section-hint {
  margin-top: 2px;
  color: #8b8d98;
  font-size: 13px;
}

.post-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px minmax(0, 1fr) 32px;
  align-items: center;
  gap: 10px;
  padding: 12px;
  margin-bottom: 10px;
  background: #f7f8ff;
  border: 1px solid #e2e5ff;
  border-radius: 12px;
}

.post-arrow {
  color: #8b8d98;
  font-size: 20px;
  text-align: center;
}

.remove-row {
  width: 30px;
  height: 30px;
  color: #ef4444;
  background: #fff;
  border: 1px solid #ffd5d5;
  border-radius: 8px;
  font-size: 20px;
  line-height: 26px;
  transition: 0.2s;
}

.remove-row:hover {
  color: #fff;
  background: #ef4444;
}

.add-row {
  padding: 10px 16px;
  color: #4b5eff;
  background: #fff;
  border: 1px dashed #4b5eff;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.add-row:hover {
  background: #f3f4ff;
}

.test-webhook-btn {
  padding: 11px 18px;
  margin-left: 10px;
  color: #fff;
  background: #4b5eff;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.test-webhook-btn--get {
  padding: 11px 18px;
  margin-left: 10px;
  color: #fff;
  background: #4b5eff;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  height: 38px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 400;
  box-shadow: none;
}

.test-webhook-btn:hover {
  background: #3949e8;
}

.test-card {
  overflow: hidden;
  border-radius: 16px !important;
  box-shadow: none !important;
}

.test-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 26px 8px;
}

.test-title {
  color: #2b2d33;
  font-size: 18px;
  font-weight: 600;
}

.test-subtitle {
  margin-top: 4px;
  color: #8b8d98;
  font-size: 14px;
}

.test-close {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #676a76;
  background: transparent;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
}

.test-close:hover:not(:disabled) { color: #4b5eff; background: #f3f4ff; }
.test-close:focus-visible { outline: 2px solid #4b5eff; outline-offset: 2px; }
.test-close:disabled { opacity: 0.45; cursor: default; }

.test-content {
  padding: 0 26px;
}

.test-call-info {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 50px;
  margin-bottom: 18px;
  text-align: center;
  background: #f3f4ff;
  border: 1px solid #dfe2ff;
  border-radius: 10px;
}

.test-call-info .test-status {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.test-call-info > div {
  width: 100%;
  text-align: center;
}

.test-call-label,
.test-info-label {
  color: #8b8d98;
  font-size: 13px;
  font-weight: 600;
}

.test-call-value {
  margin-top: 3px;
  color: #2b2d33;
  font-weight: 600;
}

.test-info-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}

.test-info-card {
  min-width: 0;
  padding: 14px 16px;
  background: #f8f9fc;
  border: 1px solid #e5e7ef;
  border-radius: 10px;
  margin-top: 12px;
  font-size: 14px;
}

.test-info-value {
  margin-top: 7px;
  overflow-wrap: anywhere;
  color: #2b2d33;
  font-size: 14px;
}

.test-payload-title {
  margin-bottom: 8px;
  color: #2b2d33;
  font-size: 15px;
  font-weight: 700;
}

.test-payload {
  max-height: 260px;
  padding: 18px;
  overflow: auto;
  color: #dfe3ff;
  background: #25283b;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.6;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
}

.test-result {
  padding: 14px 16px;
  margin-top: 16px;
  background: #f6fff9;
  border: 1px solid #bde8cb;
  border-radius: 10px;
}

.test-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 20px 26px 26px;
  background: #fff;
}

.test-cancel-btn,
.test-send-btn {
  padding: 11px 18px;
  border-radius: 8px;
  font-weight: 600;
}

.test-cancel-btn {
  color: #4b5eff;
  background: #fff;
  border: 1px solid #dfe2ff;
}

.test-send-btn {
  color: #fff;
  background: #4b5eff;
  cursor: pointer;
}

.test-send-btn:hover:not(:disabled) { background: #3949e8; }

.test-fields { margin: 8px 0 0; }
.test-fields > div {
  display: grid;
  grid-template-columns: minmax(110px, 35%) minmax(0, 1fr);
  gap: 12px;
  padding: 6px 0;
  font-size: 14px;
  line-height: 1.5;
}
.test-fields dt { color: #808185; }
.test-fields dd { margin: 0; overflow-wrap: anywhere; }
.test-result-title { font-size: 15px; font-weight: 600; }
.test-result-message { margin-top: 8px; line-height: 1.5; font-size: 14px; }

.test-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.post-row--custom {
  grid-template-columns:
    minmax(0, 1fr)
    minmax(0, 1fr)
    24px
    minmax(0, 1fr)
    32px;
}

.test-result {
  min-width: 0;
  padding: 14px 16px;
  margin-top: 16px;
  overflow: hidden;
  background: #f6fff9;
  border: 1px solid #bde8cb;
  border-radius: 10px;
}

.test-result .test-info-label {
  text-align: center;
}

.test-result--error { background: #fff3f3; border-color: #ffd0d0; }

.test-result pre {
  width: 100%;
  max-height: 220px;
  margin: 10px 0 0;
  padding: 12px;
  overflow: auto;
  color: #2b2d33;
  background: #fff;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;
  text-align: left;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.post-columns {
  display: grid;
  grid-template-columns:
    minmax(0, 1fr)
    24px
    minmax(0, 1fr)
    32px;
  align-items: end;
  gap: 10px;
  padding: 0 12px;
  margin-bottom: 8px;
}

.post-column-title {
  color: #2b2d33;
  font-size: 13px;
  font-weight: 700;
}

.post-column-hint {
  margin-top: 2px;
  color: #9a9ca6;
  font-size: 12px;
}
.source-field {
  position: relative;
  min-width: 0;
}

.custom-info-icon {
  position: absolute !important;
  top: -8px;
  right: -8px;
  z-index: 5;
  padding: 3px;
  color: #4b5eff !important;
  background: #fff;
  border: 1px solid #dfe2ff;
  border-radius: 50%;
  cursor: help;
}
.test-get-info {
  padding: 16px;
  color: #676a76;
  text-align: center;
  background: #f3f4ff;
  border: 1px solid #dfe2ff;
  border-radius: 10px;
}
@media (max-width: 650px) {
  .webhook-test-overlay { padding: 12px; }
  .test-header { padding: 18px 18px 8px; }
  .test-content { padding: 0 18px; }
  .test-actions { padding: 18px; }
  .test-fields > div { grid-template-columns: minmax(0, 1fr); gap: 2px; }
  .http {
    width: auto;
  }
}
</style>
